var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:_vm.className,attrs:{"viewBox":_vm.glyph.viewBox,"preserveAspectRatio":"xMinYMid"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.glyph.id,"href":'#' + _vm.glyph.id,"x":_vm.x,"y":_vm.y}})])
}
var staticRenderFns = []

export { render, staticRenderFns }